import DeleteIcon from '@/shared/assets/icons/deletecart.svg?react'
import { Button } from '@headlessui/react'
import clsx from 'clsx'

type Props = {
  closeButton?: boolean
  actionButton?: boolean
  isLoadActionButton?: boolean
  closeButtonName?: string
  actionButtonName?: string
  onClose?: () => void
  onAction?: () => void
  onStepBack?: () => void
  direction?: 'row' | 'column'
  actionButtonVariant?: 'purple' | 'red'
  closeButtonVariant?: 'primary' | 'icon' | 'redText' | 'purple'
}

export const ModalButtons = ({
  actionButton = true,
  closeButton = true,
  isLoadActionButton = false,
  onAction,
  onClose,
  actionButtonName = 'Создать',
  closeButtonName = 'Отмена',
  onStepBack,
  direction = 'row',
  actionButtonVariant = 'purple',
  closeButtonVariant = 'primary',
}: Props) => {
  const containerClassName = direction === 'row' ? 'flex-row justify-between' : 'flex-col-reverse'
  const baseClasses =
    'relative block w-full py-3 font-klein font-medium disabled:cursor-not-allowed disabled:opacity-75 focus:outline-none border-0 rounded-2xl focus-visible:ring-2 focus-visible:ring-card-border dark:focus-visible:ring-card-border-dark cursor-pointer'

  const closeBtnClasses = clsx(
    'ring-1 ring-inset ring-card-border dark:ring-card-border-dark focus:ring-2 focus:ring-card-border dark:focus:card-border-dark disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent hover:bg-card-border dark:hover:bg-card-border-dark',
    {
      'text-error': closeButtonVariant === 'redText',
      'text-white bg-primary hover:bg-primary-hover disabled:bg-primary-disabled dark:bg-primary-dark dark:hover:bg-primary-dark-hover dark:disabled:bg-primary-dark-disabled':
        closeButtonVariant === 'purple',
      'text-text-main dark:text-white':
        closeButtonVariant !== 'redText' && closeButtonVariant !== 'purple',
    }
  )

  const actionBtnClasses = {
    purple:
      'bg-primary hover:bg-primary-hover disabled:bg-primary-disabled dark:bg-primary-dark dark:hover:bg-primary-dark-hover dark:disabled:bg-primary-dark-disabled',
    red: 'bg-error hover:bg-[#bb251a]',
  }[actionButtonVariant]

  const primaryBtnClasses = `text-white ${actionBtnClasses}`

  return (
    <div className={`flex gap-4 mt-4 ${containerClassName}`}>
      {closeButton && (
        <Button
          onClick={onStepBack ? onStepBack : onClose}
          className={`${baseClasses} ${closeBtnClasses} flex items-center justify-center gap-[10px]`}
          disabled={onStepBack && isLoadActionButton}
        >
          <span>{closeButtonName}</span>
          {closeButtonVariant === 'icon' && <DeleteIcon className="" />}
        </Button>
      )}
      {actionButton && (
        <Button
          onClick={onAction}
          className={`${baseClasses} ${primaryBtnClasses}`}
          disabled={isLoadActionButton}
        >
          {actionButtonName}
        </Button>
      )}
    </div>
  )
}
